import React from "react";

import { SVGSprite } from "@/components/Atoms";

import Typography from "@/foundation/Typography/V2";
import { clsx } from "@/utils";

import styles from "./BenefitsSection.module.scss";

import data from "../data";

const BenefitsSection = () => {
  const { heading, benefits } = data.benefits;

  const content = (
    <div className={styles.benefits}>
      {benefits?.map(({ icon, title }, index) => (
        <div className={styles.benefit} key={index}>
          <SVGSprite className={styles.icon} icon={icon} />
          <div className={styles.title}>{title}</div>
        </div>
      ))}
    </div>
  );

  return (
    <div className={styles.benefitsSection}>
      <div className={clsx(styles.benefitsSectionContainer, "container")}>
        <Typography className={styles.heading} variant="heading2">
          {heading}
        </Typography>
        {content}
      </div>
    </div>
  );
};
export default BenefitsSection;
